// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        root:{
      fontFamily:'roboto'
        },
        gutterBottom: {
          marginBottom: 12
        }
      }
    }
  };
}
